import React from 'react'
import { useNavigate } from 'react-router'

interface PageHeaderProps {
    title?: string
    back?: boolean
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, back = false }) => {
    const navigate = useNavigate()

    // Função para navegar para a página anterior
    const handleBack = () => {
        navigate(-1)
    }

    return (
        <div className='flex flex-wrap items-center justify-between gap-3 mb-4'>
            {title && <h2 className='text-xl font-semibold text-gray-800 dark:text-white/90'>{title}</h2>}
            {back && (
                <button
                    onClick={handleBack}
                    className='inline-flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 hover:underline'
                >
                    <svg
                        className='stroke-current rotate-180'
                        width='17'
                        height='16'
                        viewBox='0 0 17 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M6.0765 12.667L10.2432 8.50033L6.0765 4.33366'
                            stroke='currentColor'
                            strokeWidth='1.2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                    Voltar
                </button>
            )}
        </div>
    )
}

export default PageHeader
